import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShowAccordion: any }>`
	width: 100%;
	display: ${(props) =>
		props.$isShowAccordion !== undefined ? 'flex' : 'none'};
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1.5rem;
	cursor: pointer;
`;

export const title = styled.div<{ $isSelect: boolean }>`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	p {
		font-size: 1.4rem;
		color: ${(props) =>
			props.$isSelect ? color.interface.lightBlue2 : color.interface.lightGray};
		font-family: nunito-regular;
		letter-spacing: 1px;

		transition: all ease 0.5s;
	}

	p:hover {
		color: ${color.interface.lightBlue2};
	}

	a {
		all: unset;
	}
`;

export const iconAccordion = styled.img`
	color: ${color.interface.darkgray2};
	width: 15px;
	cursor: 'pointer';
`;

export const arrow = styled.div`
	position: absolute;
	right: 0;
`;

export const contentAccordion = styled.div<{ $isOpen: boolean }>`
	position: relative;
	display: ${(props) => (props.$isOpen ? 'flex' : 'none')};
	flex-direction: column;
	gap: 2.5rem;
	width: 100%;
	padding-left: calc(20px + 1rem);

	animation: show 1s linear;
	transition: all ease 0.5s;

	@keyframes show {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	a {
		all: unset;
	}
`;

export const containerSuboption = styled.div<{ $isSelected: boolean }>`
	p {
		position: relative;
		font-size: 1.4rem;
		color: ${(props) =>
			props.$isSelected
				? color.interface.lightBlue2
				: color.interface.lightGray};
		font-family: nunito-regular;
		letter-spacing: 1px;

		transition: all ease 0.5s;

		:hover {
			color: ${color.interface.lightBlue2};
		}
	}
`;

export const itemLink = styled.div`
	position: relative;
`;

export const tagNew = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;

	transform: translateY(-100%);
	> p {
		font-size: 1rem;
		color: ${color.system.success};
	}
`;

export const subTagNew = styled.div`
	position: absolute;
	top: -15px;
	left: -15px;
	> p {
		font-size: 1rem;
		color: ${color.system.success};
	}
`;
